/* RESPONSIBLE TEAM: team-inbox */
import Controller from '@ember/controller';

// eslint-disable-next-line ember/no-controllers
export default class WelcomeHelpdeskController extends Controller {}
